import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ModifiersEffects } from './modifiers.effects';
import { IModifiersFeature } from './modifiers.feature.state';
import { modifiersReducer } from './modifiers.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IModifiersFeature>('modifiersFeature'), modifiersReducer),
    EffectsModule.forFeature([ModifiersEffects]),
  ],
})
export class ModifiersStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: ModifiersStateModule
  ) {
    if (parentModule) {
      throw new Error('ModifiersStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
